import styled from 'styled-components'

import { Reset } from '@/lib/mixins'

import { ScannerIndicatorWrapper } from '../Scanner/Scanner.styles'

export const ProductWrapper = styled.div`
  width: 18rem;
  margin: 0 auto;

  ${ScannerIndicatorWrapper} {
    margin-top: 1.25rem;
  }
`

export const ProductImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -1.25rem;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  width: 10rem;
  height: 14rem;
  background-color: var(--color-light);

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`

export const ProductContent = styled.div`
  h2 {
    margin-bottom: 1rem;
  }
  h6 {
    margin-bottom: 0.25rem;
  }
`

export const ProductDetails = styled.ul`
  ${Reset('list')}
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  font-size: 0.9rem;
  margin-bottom: 1rem;

  li {
    flex: 0 0 auto;

    &:not(:last-child) {
      margin-right: 1.75rem;
    }

    dl {
      margin: 0 0 1rem;
      margin-bottom: 0;
    }
  }
`

export const ProductPrice = styled.h3`
  margin-bottom: 1.25rem;
`

export const ProductEmpty = styled.div`
  max-width: 14rem;
  margin: 20vh auto;
  text-align: center;
  opacity: 0.5;
`
